export default __webpack_public_path__ + "static/media/helpful-reaction.4f1b9075.svg";